import {reduceRelayPaginationAction, RelayPaginationActionPayload, RelayPaginationState} from "providerapp/pagination";

export type ImportUserRequestDetailAction =
    | { type: 'SET_REFRESH_FUNC', refetchFunc: VoidFunction }
    | RelayPaginationActionPayload;


export interface ImportUserRequestDetailState {
    refetchFunc: VoidFunction | null;
    pagination: RelayPaginationState;
}

export function initState(): ImportUserRequestDetailState {
    return {
        pagination: new RelayPaginationState('0', 8),
        refetchFunc: null,
    };
}

export function importUserRequestDetailReducer(
    state: ImportUserRequestDetailState,
    action: ImportUserRequestDetailAction,
): ImportUserRequestDetailState {
    switch (action.type) {
        case 'RELAY_PAGINATION_ACTION':
            return {
                ...state,
                pagination: reduceRelayPaginationAction(state.pagination, action)
            };
        case 'SET_REFRESH_FUNC':
            return {
                ...state,
                refetchFunc: action.refetchFunc
            }
    }
}
